<template>
  <b-modal
    size="md"
    hide-footer
    v-model="show"
    title="Edição da Configuração do Sistema"
    @hidden="cancelar"
  >
    <b-card>
      <b-row>
        <b-col cols="12">
          <div><span class="font-weight-bold">Configuração:</span> {{ configuracao.tituloPropriedade }}</div>
        </b-col>
      </b-row>
    </b-card>
    <b-form @submit.prevent="salvar">
      <b-form-group>
        <div class="d-flex align-items-center">
          <span class="font-weight-bold">Valor:</span>
          <b-form-checkbox v-model="form.valor" :value="1" :unchecked-value="0" class="ml-2">
          </b-form-checkbox>
        </div>
      </b-form-group>
      <b-form-row class="d-flex justify-content-center">
        <b-button type="submit" size="sm" pill variant="success">
          <b-icon icon="check-circle" />
        </b-button>
        <b-button size="sm" pill variant="danger" @click="cancelar" class="ml-2">
          <b-icon icon="x-circle" />
        </b-button>
      </b-form-row>
    </b-form>
  </b-modal>
</template>

<script>
import ConfiguracaoSistemaService from "@/core/api/ConfiguracaoSistemaService";
import Swal from "sweetalert2";

export default {
  name: "ConfiguracaoGeralLogicaModal",
  props: {
    configuracao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: true,
      form: {
        valor: 0,
      },
    };
  },
  methods: {
    async salvar() {
      const payload = {
        id: this.configuracao.id,
        valorPropriedade: this.form.valor, // Envia diretamente o valor numérico 0 ou 1
      };

      try {
        await ConfiguracaoSistemaService.atualizarConfiguracao(payload);
        this.$emit("salvo");
        await Swal.fire({
          title: "Sucesso",
          text: "Configuração salva com sucesso!",
          icon: "success",
          confirmButtonText: "OK",
        });
      } catch (error) {
        this.$bvToast.toast("Erro ao salvar configuração", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
      }
    },
    cancelar() {
      this.$emit("close");
    },
    carregarDadosIniciais() {
      this.form.valor = this.configuracao.valorPropriedade === "1" ? 1 : 0;
    },
  },
  mounted() {
    this.carregarDadosIniciais();
  },
};
</script>

<style scoped>
.font-weight-bold {
  font-weight: bold;
}
</style>
